import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import ElementUI from 'element-ui';
import { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './assets/styles/reset.less';
// quill 富文本编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// 图片预览插件
// import 'lib-flexible'
// import 'viewerjs/dist/viewer.css';
// import Viewer from 'v-viewer';
// 引入常用公用组件 2020、10、04 mip
import components from '@/components'
// 引入echarts 2020、10、05 mip
import globalMixin from '@/mixins/globalMixin'
import echarts from 'echarts'
// import china from '@/jslibs/chana.json'
// echarts.registerMap('china', china);
import china from 'echarts/map/json/china.json'
echarts.registerMap('china', china)
// import china from '@/jslibs/chana.json'
// echarts.registerMap('china',china);
import { imgFilter } from './filters/vue-filters';
import { Chart } from '@antv/g2';

// import Vuebar from 'Vuebar';
import Vuebar from 'vuebar';
Vue.use(Vuebar);


//导入自定义指令
import * as alldir from './utils/directive'
Object.keys(alldir).forEach(item => {
  // 动态注册自定义指令
  Vue.directive(item, alldir[item])
})

//使用上传图片插件
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

//滚动条插件
import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

require('./jslibs/verify-code.min');
Vue.prototype.$chart = Chart
Vue.prototype.$echarts = echarts
Vue.prototype.bus = new Vue();

Vue.config.productionTip = false;
Vue.use(ElementUI, { size: 'mini' });
// Vue.use(Viewer);
Vue.use(components);
Vue.use(globalMixin);
Vue.filter('imgMapper', imgFilter);

Vue.prototype.$message = function (msg) {
  let obj = (typeof msg == 'string') ? { message: msg } : msg
  return Message({
    duration: 1000,
    ...obj
  })
}

Vue.prototype.$message.success = function (msg) {
  return Message.success({
    message: msg,
    duration: 1000
  })
}
Vue.prototype.$message.warning = function (msg) {
  return Message.warning({
    message: msg,
    duration: 1000
  })
}
Vue.prototype.$message.error = function (msg) {
  return Message.error({
    message: msg,
    duration: 1000
  })
}

import { Loading } from 'element-ui';
router.beforeEach((to, from, next) => {
  Loading.service({text:'加载中'});
  if (to.name == from.name) {
    next(false);
  }
  // 这里拦截 检查 用户信息 图片域名
  if (to.name == 'login') {
    next()
    return false;
  }
  if (!store.state.imgDomain || !(store.state.loginData && store.state.loginData.uuid)) {
    next({ name: 'login' })
    return false;
  }
  next()
})
router.afterEach((to, from)=>{
 setTimeout(() => {
  Loading.service().close();
 }, 1000);
})
window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');